import { Building2, Plus, Trash2, LogOut, BookOpen, LayoutDashboard, UserCog, Users, History } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { ThemeSwitcher } from "./ThemeSwitcher";

export const SitesSidebar = ({ sites, activeId, onSelect, onAdd, onDelete, user, onLogout, view, onOverview, onStaff, onActivity, onAccount }) => {
  const { isAdmin, can } = useAuth();
  return (
  <aside className="bg-side border-r border-line text-ink lg:w-64 lg:min-h-screen flex flex-col" data-testid="sites-sidebar">
    <div className="p-5 flex items-center gap-2 font-display text-lg font-semibold border-b border-line">
      <BookOpen className="h-5 w-5 text-brand" /> SiteLedger
    </div>
    <div className="px-5 py-3 border-b border-line flex items-center justify-between gap-2">
      <ThemeSwitcher />
      <div className="flex items-center gap-1">
        <button onClick={onAccount} className="p-1.5 hover:bg-hover transition-colors" title="My Account" aria-label="My Account" data-testid="my-account-button">
          <UserCog className="h-4 w-4" />
        </button>
        <button onClick={onLogout} className="p-1.5 hover:bg-hover transition-colors lg:hidden" title="Logout" aria-label="Logout" data-testid="sidebar-mobile-logout-button">
          <LogOut className="h-4 w-4" />
        </button>
      </div>
    </div>
    <div className="px-3 pt-3 flex lg:flex-col gap-1">
      {can("dashboard") && <button onClick={onOverview} data-testid="nav-dashboard-button"
        className={`w-full flex items-center gap-2 px-3 py-2 text-sm transition-colors ${view === "overview" ? "bg-brand text-onbrand" : "hover:bg-hover"}`}>
        <LayoutDashboard className="h-4 w-4 opacity-70" /> Dashboard
      </button>}
      {isAdmin && <button onClick={onStaff} data-testid="nav-staff-button"
        className={`w-full flex items-center gap-2 px-3 py-2 text-sm transition-colors ${view === "staff" ? "bg-brand text-onbrand" : "hover:bg-hover"}`}>
        <Users className="h-4 w-4 opacity-70" /> Staff
      </button>}
      {isAdmin && <button onClick={onActivity} data-testid="nav-activity-button"
        className={`w-full flex items-center gap-2 px-3 py-2 text-sm transition-colors ${view === "activity" ? "bg-brand text-onbrand" : "hover:bg-hover"}`}>
        <History className="h-4 w-4 opacity-70" /> Activity
      </button>}
    </div>
    <div className="px-5 pt-5 pb-2 flex items-center justify-between">
      <span className="font-mono text-[11px] uppercase tracking-widest text-muted-c">Books / Sites</span>
      {isAdmin && <button onClick={onAdd} className="p-1 hover:bg-hover transition-colors" data-testid="add-site-button" aria-label="Add site">
        <Plus className="h-4 w-4" />
      </button>}
    </div>
    <nav className="flex lg:flex-col gap-1 px-3 overflow-x-auto lg:overflow-visible pb-3 lg:flex-1">
      {sites.length === 0 && <p className="px-2 text-sm text-muted-c">{isAdmin ? "No sites yet" : "No books assigned"}</p>}
      {sites.map((s) => (
        <div key={s.id} className={`group flex items-center shrink-0 transition-colors ${s.id === activeId && view === "site" ? "bg-brand text-onbrand" : "hover:bg-hover"}`}>
          <button onClick={() => onSelect(s.id)} className="flex-1 flex items-center gap-2 px-3 py-2 text-left text-sm" data-testid={`site-item-${s.id}`}>
            <Building2 className="h-4 w-4 opacity-70" />
            <span className="truncate">{s.name}</span>
            <span className="ml-auto font-mono text-[10px] opacity-60">{s.branch_count}</span>
          </button>
          {isAdmin && <button onClick={() => onDelete(s)} className="p-2 opacity-60 lg:opacity-0 group-hover:opacity-100 hover:text-red-300 transition-opacity" data-testid={`delete-site-${s.id}`} aria-label="Delete site">
            <Trash2 className="h-3.5 w-3.5" />
          </button>}
        </div>
      ))}
    </nav>
    <div className="hidden lg:block p-4 border-t border-line">
      <p className="text-xs text-muted-c truncate" data-testid="current-user-email">{user?.email}</p>
      <p className="font-mono text-[10px] uppercase tracking-widest text-brand mt-0.5" data-testid="current-user-role">{isAdmin ? "Admin" : "Staff"}</p>
      <Button variant="ghost" size="sm" onClick={onLogout} className="mt-2 px-0 text-ink2 hover:text-ink hover:bg-transparent" data-testid="logout-button">
        <LogOut className="h-4 w-4 mr-2" /> Logout
      </Button>
    </div>
  </aside>
  );
};
